<template>
    
    <div :class="'p-3 flex content-main ' + (action.component ? ' half-it gap-5' : 'gap-5')">
      <div class="custom-full">
      
        <template v-if="vg_selectedLocation.id">
        <div class="bg-[#2B2C32] rounded-lg mt-1 pt-1 pb-5">
          <div class="flex justify-between mt-3 h-[40px]">
            <h2 class="text-white font-semibold text-[20px]">Access Tokens</h2>
            <button  class="text-white bg-theme-green hover:bg-green-600 py-1 h-10 px-1 text-2xl border-0 rounded-md cursor-pointer" @click="addUpdate({ component: 'Add', data: {}})" v-if="!action.component">
              <span>
                <svg fill="currentColor" width="32" height="32" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z"></path>
                </svg>
              </span>
            </button>
          </div>
          <List :selectedItemCallback="selectedItem" :clearComponent="clearComponent" :iscomponentactive="action.component ? true : false"/>
        </div>
        </template>
        <div v-else class="bg-[#2B2C32] rounded-lg px-8 mt-1 pt-1 pb-5">
          <p class="text-center text-theme-red mt-3">Please select a location.</p>
        </div>
      </div>

        <div :class="'w-full hidden-component'" v-if="action.component" >
        <component :is="action.component" :item="action.data" :clearComponent="clearComponent"></component>
      </div>

    </div>
    
  </template>
  
  
  <script lang="ts">
  import {defineComponent, ref} from "vue"
  import { mapGetters, mapActions, mapMutations } from "vuex";
  import Nav from '@/views/Location/Integrations/Nav.vue';
  import List from '@/views/Location/Integrations/AccessToken/List.vue';
  import Add from '@/views/Location/Integrations/AccessToken/Add.vue';
  import Update from '@/views/Location/Integrations/AccessToken/Update.vue';
  
  export default defineComponent({
    name: "LocationIntregationIndex",
    components: {
     Nav,
     List,
     Add,
     Update
    },
  
    setup() {
      const action = ref<object>({
        component: '',
        data: {},
      });
      return {
        action,
      };
    },
  
     watch: {
      'vg_selectedLocation'(val) {
        // if location selected clear component
        this.clearComponent();
      },
    },
  
    computed: {
      ...mapGetters({
       vg_selectedLocation: 'location/selected'
      }),
    },
  
    mounted() {
     
    },
  
    beforeDestroy() {
     
    },
   
    methods: {
      /**
       * Clear action
       */
      clearComponent() {
        this.action = {
          component: '',
          data: {},
        };
      },
  
      /**
       * Change add / update component
       */
      addUpdate(val: any) {
        this.action = val;
      },
  
      /**
       * Capture selected item
       */
      selectedItem(item) {
        this.addUpdate({
          component: 'Update', 
          data: item
        })
      },
  
      ...mapActions({
        va_spinner: 'spinner/setSpinner',
      })
    },
  });
  
  </script>
  
  